<template>
  <div class="wrapper wrapper-full-page setup-password-page">
    <div class="full-page login-page page-content">
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-sm-6 offset-sm-3 col-xl-4 offset-xl-4">
              <form
                v-loading="isLoading"
                method="post"
                element-loading-text="Creating Password..."
                element-loading-custom-class="spinner-class"
                @submit.prevent="submitForm"
              >
                <div class="card">
                  <div class="card-header justify-content-center">
                    <h3 class="card-title">
                      Setup Password
                    </h3>
                  </div>

                  <div class="card-content">
                    <password-fields-container
                      v-model:password="user.password"
                      v-model:confirm-password="user.confirmPassword"
                      row-class="form-group mb-20"
                      lbl-class="pl-0"
                      field-class=""
                      @update-validation="updatePasswordValidation"
                    />
                  </div>

                  <div class="card-footer form-submit-button-group pt-5 mobile-pt-10">
                    <p-button
                      data-test="btn-login"
                      native-type="submit"
                      type="purple"
                      round
                      class="btn-login mb-10"
                      :disabled="!isValidPassword"
                    >
                      Create Password
                    </p-button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="full-page-background" />
    </div>
  </div>
</template>

<script lang="ts">
import { ref, reactive, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import util from '@/Utils/util';
import { useSwalDialog } from '@/use/swalDialog';
import { sendPost } from '@/Utils/api';

export default {
  setup: () => {
    const route = useRoute();
    const router = useRouter();

    const { showSuccessPopupDialog, showErrorPopupDialog } = useSwalDialog();

    const user = reactive({
      token: '',
      password: '',
      confirmPassword: '',
    });

    const isLoading = ref(false);
    const isValidPassword = ref(false);

    const updatePasswordValidation = (value: boolean) => {
      isValidPassword.value = value;
    };

    const submitForm = async () => {
      isLoading.value = true;

      try {
        await sendPost(`reset/${user.token}`, {
          password: user.password,
          confirm: user.confirmPassword,
        });

        await showSuccessPopupDialog({
          title: 'Your password has been created successfully.',
        });
        router.push('/login');
      } catch (err) {
        const errorText = util.getErrorResponse(err, false);
        showErrorPopupDialog({
          text: errorText,
        });
      } finally {
        isLoading.value = false;
      }
    };

    onMounted(() => {
      user.token = (route.params.token || '') as string;
    });

    return {
      user,
      isLoading,
      isValidPassword,

      updatePasswordValidation,
      submitForm,
    };
  },
};
</script>

<style lang="scss">
.setup-password-page {
  .page-content {
    .content {
      .container {
        margin-top: 4vh;
      }
    }
    .password-fields-container {
      .condition-case-wrapper {
        margin-top: -20px;

        .condition-case {
          color: #fff;
        }
      }
    }
  }
}
</style>
